/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const myLevelValueSchema = z.object({
  subBand: z.string(),
  level: z.string().nullable(),
  score: z.number().int(),
  source: z.string(),
  measuredAt: z.number(),
});

export const myLevelV1DataSchema = z.discriminatedUnion('exists', [
  z.object({ exists: z.literal(false) }),
  z.object({ exists: z.literal(true), value: myLevelValueSchema }),
]);

export type IMyLevelV1Data = z.infer<typeof myLevelV1DataSchema>;

export const getMyLevelV1ResponseSchema = createApiResponseSchema(
  myLevelV1DataSchema,
) as import('zod').ZodSchema<IAPI<IMyLevelV1Data>>;

export type IGetMyLevelV1Response = IAPI<IMyLevelV1Data>;
